import React from 'react';
import CommonCard from './CommonCard';
import HotSearchContent from './HotSearchContent';
import { DATA_TYPE, PREFERRED_ICON_TYPE } from '../../../config/TypeConfig';
import languageManager from '../../../utils/languageManager';

const HotSearch = ({ onSave }) => {
  const handleAdd = () => {
    // 组装热搜卡片网站数据
    const websiteData = {
      name: languageManager.t('cards.hotSearch'),
      iconColor: '#ffffff', // 白色
      textIcon: languageManager.t('cards.hotSearch'),
      url: 'https://www.aidengta.cn',
      dataType: DATA_TYPE.HOT_SEARCH, // 使用枚举值代表热搜卡片
      id: `hotsearch_${Date.now()}_${Math.random().toString(36).substring(2, 8)}`,
      iconUrl: '', // 热搜卡片不需要图标URL
      preferredIconType: PREFERRED_ICON_TYPE.TEXT, // 使用枚举值表示文本图标
      category: languageManager.t('cards.hotSearch'), // 分类
      description: languageManager.t('cards.hotSearchDescription')
    };

    // 调用父组件的 onSave 方法
    if (onSave) {
      onSave(websiteData);
    }
  };

  return (
    <CommonCard
      title={languageManager.t('cards.hotSearch')}
      subtitle={languageManager.t('cards.hotSearchSubtitle')}
      onAdd={handleAdd}
      addButtonText={languageManager.t('common.add')}
      scrollDirection="vertical"
    >
      <HotSearchContent />
    </CommonCard>
  );
};

export default HotSearch; 